<div class="filter-row">
  <button type="button"
          class="filter-chip"
          [class.active]="activeFilter === null"
          (click)="setFilter(null)">All</button>
  <button *ngFor="let cat of availableCategories"
          type="button"
          class="filter-chip"
          [class.active]="activeFilter === cat"
          (click)="setFilter(cat)">{{ cat }}</button>
  <button type="button" class="add-habit-btn" (click)="addHabit.emit()">+ Habit</button>
</div>

<section class="habit-section" *ngIf="dailyHabits.length">
  <h2 class="section-title">Daily</h2>
  <app-habit-card
    *ngFor="let h of dailyHabits; trackBy: trackHabit"
    [habit]="h"
    [todayCompletion]="todayCompletionFor(h)"
    [last7Days]="last7DaysFor(h)"
    [streak]="streakByHabitId[h.id] || 0"
    (toggle)="toggleDaily.emit(h)"
    (noteChange)="noteChange.emit($event)"
    (editHabit)="editHabit.emit(h)">
  </app-habit-card>
</section>

<section class="habit-section" *ngIf="weeklyHabits.length">
  <h2 class="section-title">Weekly</h2>
  <app-weekly-goal-card
    *ngFor="let h of weeklyHabits; trackBy: trackHabit"
    [habit]="h"
    [weekCompletions]="weekCompletionsFor(h)"
    [today]="today"
    (toggle)="toggleWeekly.emit(h)"
    (removeCompletion)="removeWeeklyCompletion.emit($event)"
    (noteChange)="noteChange.emit($event)"
    (editHabit)="editHabit.emit(h)">
  </app-weekly-goal-card>
</section>

<div *ngIf="!dailyHabits.length && !weeklyHabits.length" class="empty-state">
  <p *ngIf="activeFilter">No habits match the <strong>{{ activeFilter }}</strong> filter.</p>
  <p *ngIf="!activeFilter">No habits yet. Click <strong>+ Habit</strong> to add one.</p>
</div>
